{
  "version": 1,
  "asset_id": "d006c56a-78db-4f25-87e6-c9d983153a5d",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/d006c56a-78db-4f25-87e6-c9d983153a5d/og-home.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/d006c56a-78db-4f25-87e6-c9d983153a5d/og-home.jpg",
  "original_filename": "og-home.jpg",
  "size": 143453,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T16:20:15Z"
}
